import { Component, OnInit, inject } from "@angular/core";
import { DashboardWidgetMapping } from "../shared/DashboardWidgetMapping";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { DashboardWidgetModel } from "../shared/models/DashboardWidgetModel";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/dashboard/i18n/scope";
import { catalogKey } from "../shared/translateWidgetCatalogField";
import { DebounceInputEventDirective } from "@app/shared/directives/debounce-input-event.directive";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "widget-market",
    templateUrl: "./widget-market.component.html",
    styleUrls: ["./widget-market.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, DebounceInputEventDirective, InputTooltipDirective],
})
export class WidgetMarketComponent implements OnInit {
    private _permService = inject(PermissionsService);
    private _translation = injectTranslation(scope);

    marketWidgets: DashboardWidgetModel[];
    filteredMarketWidgets: DashboardWidgetModel[];

    draggingMarketItem: DashboardWidgetModel;

    readonly catalogKey = catalogKey;

    async ngOnInit() {
        await this._translation.ready();
        this.initMarketItems();
        this.filter(null);
    }

    dragStartHandler(ev: DragEvent, draggingItem: DashboardWidgetModel) {
        this.draggingMarketItem = draggingItem;

        ev.dataTransfer.setData("text/plain", JSON.stringify(draggingItem.customConfig));
        ev.dataTransfer.dropEffect = "copy";
    }

    filter(filterString: string) {
        if (!filterString || filterString.trim() === "") {
            this.filteredMarketWidgets = this.marketWidgets;
            return;
        }

        filterString = filterString.trim().toLowerCase();

        this.filteredMarketWidgets = this.marketWidgets.filter((mw) => {
            const title = this._translation.t(catalogKey(mw.title));
            const description = mw.description ? this._translation.t(catalogKey(mw.description)) : "";
            return (
                title.toLowerCase().indexOf(filterString) >= 0 ||
                description.toLowerCase().indexOf(filterString) >= 0
            );
        });
    }

    private initMarketItems() {
        const allWidgets = DashboardWidgetMapping.all();
        const sortedWidgets = this.SortWidgets(allWidgets);

        this.marketWidgets = sortedWidgets.filter((widget) => {
            if (!widget.right) {
                return true;
            }

            return this._permService.hasStringRight(widget.right);
        });
    }

    private SortWidgets(widgets: DashboardWidgetModel[]) {
        var sortedWidgets = widgets.sort((n1, n2) => {
            const title1 = this._translation.t(catalogKey(n1.title)).toLocaleLowerCase();
            const title2 = this._translation.t(catalogKey(n2.title)).toLocaleLowerCase();

            if (title1 > title2) {
                return 1;
            }

            if (title1 < title2) {
                return -1;
            }

            return 0;
        });
        return sortedWidgets;
    }
}
